import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
import { isMobile } from '../../../utils/utils';
export class AibaAnalysisSteps {
  constructor() {
    this.toggle = undefined;
    this.header = undefined;
    this.styles = undefined;
    this.accordion = undefined;
    this.arrowUpIcon = undefined;
    this.arrowDownIcon = undefined;
    this.arrowIconalt = undefined;
    this.handlers = undefined;
    this.analysisStepsContent = undefined;
    this.analysisStepsButton = undefined;
    this.classes = undefined;
    this.cols = 1;
    this.defaultAccordion = undefined;
  }
  async handleButtonClick(e, eventName) {
    if (eventName) {
      this.handlers && this.handlers[eventName](e);
    }
    else {
      this.handlers && this.handlers['handleClick'](e);
    }
  }
  viewAnalysisSteps() {
    const analysisStepsList = this.analysisStepsContent;
    return (h("div", null, analysisStepsList === null || analysisStepsList === void 0 ? void 0 : analysisStepsList.map((item) => {
      return h("aiba-content-block", { _id: item._id, data: item === null || item === void 0 ? void 0 : item.data });
    })));
  }
  render() {
    if (typeof this.analysisStepsContent === 'string') {
      if (this.analysisStepsContent)
        this.analysisStepsContent = JSON.parse(this.analysisStepsContent);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `${this.getCssClassMap()} ${this.classes ? this.classes : ''}` }, h("aiba-accordion", { accordionData: () => this.viewAnalysisSteps && this.viewAnalysisSteps(), arrowDownIcon: this.arrowDownIcon, arrowUpIcon: this.arrowUpIcon, header: this.header, toggle: false, isAccordion: !!isMobile(), handlers: this.handlers, defaultAccordion: this.defaultAccordion ? this.defaultAccordion : false }), this.analysisStepsButton && (h("aiba-button", Object.assign({}, this.analysisStepsButton['data'], { handleClick: (e) => { var _a, _b; return this.handleButtonClick(e, (_b = (_a = this.analysisStepsButton) === null || _a === void 0 ? void 0 : _a['data']) === null || _b === void 0 ? void 0 : _b['handleClick']); } }))))));
  }
  getCssClassMap() {
    return classNames(`analysis-steps`);
  }
  static get is() { return "aiba-analysis-steps"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-analysis-steps.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-analysis-steps.css"]
    };
  }
  static get properties() {
    return {
      "header": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "header",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "accordion": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "accordion",
        "reflect": false
      },
      "arrowUpIcon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arrow-up-icon",
        "reflect": false
      },
      "arrowDownIcon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arrow-down-icon",
        "reflect": false
      },
      "arrowIconalt": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arrow-iconalt",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "analysisStepsContent": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "analysis-steps-content",
        "reflect": false
      },
      "analysisStepsButton": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "analysis-steps-button",
        "reflect": false
      },
      "classes": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "cols": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cols",
        "reflect": false,
        "defaultValue": "1"
      },
      "defaultAccordion": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "default-accordion",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "toggle": {}
    };
  }
}
//# sourceMappingURL=aiba-analysis-steps.js.map
